"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M14 8C12.896 8 12 7.104 12 6C12 4.896 12.896 4 14 4C15.104 4 16 4.896 16 6C16 7.104 15.104 8 14 8ZM15.636 16H11.11C10.939 16 10.854 15.794 10.975 15.674L12.182 14.472L13.452 13.115C13.594 12.983 13.824 12.983 13.966 13.115L15.893 15.425C16.122 15.637 15.959 16 15.636 16ZM9.408 16H4.306C3.767 16 3.605 15.404 3.986 15.057L7.948 11.162C8.185 10.946 8.568 10.946 8.804 11.162L11.508 13.799C11.58 13.873 11.579 13.993 11.505 14.066L9.677 15.889C9.606 15.96 9.509 16 9.408 16ZM17 2H3C2.448 2 2 2.447 2 3V17C2 17.553 2.448 18 3 18H17C17.552 18 18 17.553 18 17V3C18 2.447 17.552 2 17 2Z",
    fill: "#727B7F"
  }));
};